import { STORE_CONSTANTS } from '../actionTypes'
import { isMobile } from 'react-device-detect'

const initState = {
	allStores: [],
	stores: [],
	loading: false,
	pageIndex: isMobile
		? process.env.REACT_APP_STORES_PER_PAGE_MOBILE
		: process.env.REACT_APP_PRODUCTS_PER_PAGE_DESKTOP,
	pageCount: 1,
	totalPages: 1,
	pageNumber: 1,
	loadMore: false,
}
let response

const storeReducer = (state = initState, action) => {
	switch (action.type) {
		case 'RESET':
			return initState
		case STORE_CONSTANTS.ACCESS_NEW_STORE:
			response = action?.response
			return {
				...state,
				// allStores: state?.allStores,
				// stores: state?.stores,
				// totalPages: state?.totalPages,
				// pageCount: state?.pageCount,
				// pageNumber: state?.pageNumber,
				// pageIndex: isMobile ? process.env.REACT_APP_STORES_PER_PAGE_MOBILE : process.env.REACT_APP_STORES_PER_PAGE_DESKTOP,
			}
		case STORE_CONSTANTS.SHOP_LISTING_REQUEST:
			return {
				...state,
				loading: true,
			}
		case STORE_CONSTANTS.SHOP_LISTING_SUCCESS:
			response = action?.response
			return {
				...state,
				loading: false,
				allStores: response?.shopList,
				pageIndex: isMobile
					? process.env.REACT_APP_STORES_PER_PAGE_MOBILE
					: process.env.REACT_APP_STORES_PER_PAGE_DESKTOP,
			}
		case STORE_CONSTANTS.SHOP_LISTING_FAILURE:
			return {
				...state,
				loading: false,
			}
		case STORE_CONSTANTS.UPDATE_STORE_LISTING_PAGE:
			response = action?.response
			return {
				...state,
				stores: response?.stores,
				totalPages: response?.totalPageCount,
			}
		case STORE_CONSTANTS.UPDATE_VISIBLE_STORE_PAGE_INDEX:
			response = action?.response
			return {
				...state,
				stores: [...state?.stores, ...response?.stores],
				pageCount: response?.pageCount,
				pageNumber: response?.pageNumber,
				loadMore: false,
			}

		case STORE_CONSTANTS.CLEAR_PAGE_NUMBER:
			return {
				...state,
				pageNumber: initState.pageNumber,
			}
		case STORE_CONSTANTS.LOAD_MORE_STORES:
			return {
				...state,
				loadMore: true,
			}

		default:
			return state
	}
}
export default storeReducer
